import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cn-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.fechar.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "cn-modal"
  }, [_c('div', {
    staticClass: "cn-modal__header"
  }, [_c('div', [_vm._m(0), _vm.nfce ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" NFC-e #" + _vm._s(_vm.nfce.numero || _vm.nfce.numeroNota) + " · Série " + _vm._s(_vm.nfce.serie) + " ")]) : _vm._e()]), _c('button', {
    staticClass: "cn-btn cn-btn--light",
    attrs: {
      "disabled": _vm.enviando
    },
    on: {
      "click": _vm.fechar
    }
  }, [_vm._v("✕")])]), _c('div', {
    staticClass: "cn-modal__body"
  }, [_vm._m(1), _vm.nfce && _vm.nfce.chave ? _c('div', {
    staticClass: "cn-meta"
  }, [_c('strong', [_vm._v("Chave:")]), _c('code', {
    staticClass: "cn-chave"
  }, [_vm._v(_vm._s(_vm.nfce.chave))])]) : _vm._e(), _c('div', {
    staticClass: "cn-form-group"
  }, [_vm._m(2), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.justificativa,
      expression: "justificativa"
    }],
    staticClass: "cn-textarea",
    attrs: {
      "rows": "4",
      "maxlength": _vm.JUSTIFICATIVA_MAX,
      "disabled": _vm.enviando,
      "placeholder": "Ex: Cancelamento solicitado pelo cliente"
    },
    domProps: {
      "value": _vm.justificativa
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.justificativa = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "cn-counter",
    class: {
      'text-danger': _vm.caracteresInsuficientes
    }
  }, [_vm._v(" " + _vm._s(_vm.justificativa.trim().length) + "/" + _vm._s(_vm.JUSTIFICATIVA_MAX) + " "), _vm.caracteresInsuficientes ? _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(" A justificativa deve ter entre " + _vm._s(_vm.JUSTIFICATIVA_MIN) + " e " + _vm._s(_vm.JUSTIFICATIVA_MAX) + " caracteres. ")]) : _vm._e()])]), _vm.erro ? _c('div', {
    staticClass: "cn-alert cn-alert--danger"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle mr-2"
  }), _vm._v(_vm._s(_vm.erro) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "cn-modal__footer"
  }, [_c('button', {
    staticClass: "cn-btn cn-btn--ghost",
    attrs: {
      "disabled": _vm.enviando
    },
    on: {
      "click": _vm.fechar
    }
  }, [_vm._v("Voltar")]), _c('button', {
    staticClass: "cn-btn cn-btn--danger",
    attrs: {
      "disabled": !_vm.podeEnviar || _vm.enviando
    },
    on: {
      "click": _vm.confirmar
    }
  }, [_vm.enviando ? _c('span', [_c('span', {
    staticClass: "spinner-border spinner-border-sm mr-2"
  }), _vm._v("Enviando à SEFAZ... ")]) : _c('span', [_c('i', {
    staticClass: "fas fa-ban mr-1"
  }), _vm._v("Cancelar NFC-e ")])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h4', {
    staticClass: "cn-modal__title"
  }, [_c('i', {
    staticClass: "fas fa-ban mr-2"
  }), _vm._v("Cancelar NFC-e ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "cn-alert cn-alert--info"
  }, [_c('i', {
    staticClass: "fas fa-info-circle mr-2"
  }), _vm._v(" Deseja realmente cancelar esta NFC-e? Essa ação será enviada para a SEFAZ. ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    staticClass: "cn-label"
  }, [_vm._v("Justificativa do cancelamento "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]);
}];
export { render, staticRenderFns };